// extracted by mini-css-extract-plugin
export var avatar = "_n4-3";
export var avatarContainer = "_n4-2";
export var avatarSpacer = "_n4-5";
export var avatarSpacerContainer = "_n4-4";
export var avatarStackContainer = "_n4-1";
export var bubble = "_n4-0";
export var remainderBubble = "_n4-6";